import { http } from "./http.js";

async function getColumnSettings(resource) {
  const response = await http.get(`column-settings/by-resource/${resource}`);
  return response.data.map(s => {
    return {
      id: s.Id,
      title: s.Title,
      settings: s.Settings,
    };
  });
}

async function getDataFromApi(url, filterParams) {
  const response = await http.get(url + filterParams);
  return response;
}

async function downloadOutputForm(resource, filterParams) {
  const response = await http.get(`${resource}/output-xlsx?` + filterParams, {
    responseType: "arraybuffer",
  });
  return response;
}

async function getSettings(id) {
  const response = await http.get(`column-settings/${id}`);
  return response;
}

async function changeDateSettings(id) {
  const response = await http.patch(`column-settings/${id}/date`);
  return response;
}

async function updateColumnSettings(id, setting) {
  const response = await http.put(`column-settings/${id}`, setting);
  return response.data.map(s => {
    return {
      id: s.Id,
      title: s.Title,
    };
  });
}

async function createColumnSettings(setting) {
  const response = await http.post("column-settings", setting);
  return response.data.map(s => {
    return {
      id: s.Id,
      title: s.Title,
    };
  });
}

async function deleteSetting(id) {
  const response = await http.delete(`column-settings/${id}`);
  return response;
}

async function getSavedFilter(id) {
  const response = await http.get(`saved-filters/${id}`);
  return response;
}

async function updateSavedFilter(id, filter) {
  const response = await http.put(`saved-filters/${id}`, filter);
  return response.data.map(f => {
    return {
      id: f.Id,
      title: f.Title,
      isShared: f.IsShared,
      userId: f.UserId,
    };
  });
}

async function createSavedFilter(filter) {
  const response = await http.post("saved-filters", filter);
  return response.data.map(f => {
    return {
      id: f.Id,
      title: f.Title,
      isShared: f.IsShared,
      userId: f.UserId,
    };
  });
}

async function deleteSavedFilter(store, id) {
  const response = await http.patch(`${store}/saved-filters/${id}`);
  return response.data.map(f => {
    return {
      id: f.Id,
      title: f.Title,
      isShared: f.IsShared,
      userId: f.UserId,
    };
  });
}

async function shareSavedFilter(store, id, value) {
  const response = await http.patch(
    `${store}/saved-filters/${id}/change-is-shared`,
    {
      value,
    },
  );
  return response.data.map(f => {
    return {
      id: f.Id,
      title: f.Title,
      isShared: f.IsShared,
      userId: f.UserId,
    };
  });
}

async function getSavedFiltersByPage(store) {
  const response = await http.get(`saved-filters/by-page/${store}`);
  return response.data.map(f => {
    return {
      id: f.Id,
      title: f.Title,
      isShared: f.IsShared,
      userId: f.UserId,
    };
  });
}

async function getItemsFromApi(url) {
  const response = await http.get(url);
  return response;
}

async function saveColumnSettings(resource, columns) {
  const response = await http.post("column-settings", {
    resource,
    settings: JSON.stringify(columns),
  });
  return response;
}

export {
  getColumnSettings,
  getDataFromApi,
  downloadOutputForm,
  getSettings,
  changeDateSettings,
  updateColumnSettings,
  createColumnSettings,
  deleteSetting,
  getSavedFilter,
  updateSavedFilter,
  createSavedFilter,
  deleteSavedFilter,
  shareSavedFilter,
  getSavedFiltersByPage,
  getItemsFromApi,
  saveColumnSettings,
};
